import { useSelector } from 'react-redux';

import { TransactionSelector } from '@features/Transaction';
import { Button } from 'antd';
import { Constants } from 'common/constants';
import { useHistory } from 'react-router';
const handlePrint = () => {
  window.print();
};
export const DownloadOR = () => {
  const transactionState = useSelector(TransactionSelector);
  const history = useHistory();
  return (
    <div className="ml-50">
      <Button className="PrintBtn non-printable mr-10" size="large" type="default" onClick={() => history.goBack()}>
        {Constants.BTN_CLOSE}
      </Button>
      <Button className="PrintBtn non-printable" size="large" type="primary" onClick={handlePrint}>
        Print
      </Button>
      <br />
      <br />
      <br />
      <br />
      <div dangerouslySetInnerHTML={{ __html: transactionState.DownloadOR || '' }} />
    </div>
  );
};
